// funtion convert format voucher
export const formatVoucherString = (voucher) => {

    console.log(voucher);
    // Extraer el número de tarjeta ocultando los dígitos intermedios
    const maskedVoucher = voucher.replace(/(\d{6})\d+(\d{4})/g, "$1XXXXXX$2");

    // Construir el string formateado del voucher
    const formattedVoucher = `${maskedVoucher}`;
    return (formattedVoucher)
};